import { useState } from 'react';
import { createRoute, Link } from '@tanstack/react-router';
import { FlaskConical, Plus } from 'lucide-react';
import { rootRoute } from './__root';
import { SitesTable } from '@/components/sites-table';
import { AddSiteModal } from '@/components/add-site-modal';
import { Button, buttonClasses } from '@/components/ui/button';
import { useCurrentIdentity } from '@/lib/identity-context';

export const sitesListRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/',
  component: SitesListPage,
});

function SitesListPage() {
  const { hasPermission } = useCurrentIdentity();
  const [addOpen, setAddOpen] = useState(false);
  const canCreate = hasPermission('sites:write');
  const canRunHarness = hasPermission('harness:run');

  return (
    <div className="flex flex-col gap-4">
      <div className="flex items-start justify-between gap-4">
        <div>
          <h1 className="text-2xl font-semibold">Sites</h1>
          <p className="text-sm text-muted-foreground">
            Monitored sites, their latest crawl status, and baseline drift.
          </p>
        </div>
        <div className="flex items-center gap-2">
          {canRunHarness && (
            <Link
              to="/harness"
              className={buttonClasses({ size: 'sm', variant: 'outline' })}
              data-testid="harness-scan-trigger"
            >
              <FlaskConical className="h-3.5 w-3.5" />
              Run harness scan
            </Link>
          )}
          {canCreate && (
            <Button
              size="sm"
              onClick={() => setAddOpen(true)}
              data-testid="add-site-trigger"
            >
              <Plus className="h-3.5 w-3.5" />
              Add site
            </Button>
          )}
        </div>
      </div>
      <SitesTable />
      {addOpen && <AddSiteModal onClose={() => setAddOpen(false)} />}
    </div>
  );
}
